import Image from "react-bootstrap/Image";
import Nodata from "../../assets/images/Nodata.svg";
import { StyledButton } from "../../styles/StyledCDButton";
import { redirectToNewTab } from "../../utils/common";
import { Wrapper } from "../../styles/norecord.styles";
import { CDVALET_BASE_URL } from "../../utils/constant";

export const NoAffiliateSection = () => (
  <Wrapper>
    <Image src={Nodata} height={150} width={150} alt="search_empty" />
    <div className="no-record-label mb-0">No Offers Available Right Now</div>
    <div className="no-record-sub-label">Try again later or view current rates </div>
    <div className="button-wrapper">
      <StyledButton
        className="explore-top-cd-rates"
        $customColor="var(--cdv-btn-bg)"
        onClick={() => redirectToNewTab(CDVALET_BASE_URL)}
        type="button"
        role="button"
      >
        Explore Top CD Rates
      </StyledButton>
    </div>
  </Wrapper>
);
